document.addEventListener('DOMContentLoaded', function () {
  var stage = document.querySelector('.psp-core-stage');
  if (!stage) return;
  var svg = stage.querySelector('.psp-core-svg');
  if (!svg) return;

  function updateLines() {
    if (getComputedStyle(stage).display === 'none') return;
    var stageRect = stage.getBoundingClientRect();
    if (!stageRect.width || !stageRect.height) return;
    var vb = svg.viewBox.baseVal;
    var scaleX = vb.width / stageRect.width;
    var scaleY = vb.height / stageRect.height;

    var leftCards = stage.querySelectorAll('.psp-core-col.left .psp-core-card');
    leftCards.forEach(function (card, i) {
      var r = card.getBoundingClientRect();
      var x = (r.right - stageRect.left) * scaleX;
      var y = (r.top + r.height / 2 - stageRect.top) * scaleY;
      var d = 'M' + x + ',' + y + ' C 300,' + y + ' 300,280 440,280';
      var path = document.getElementById('psp-core-path-left-' + i);
      var anim = document.getElementById('psp-core-anim-left-' + i);
      if (path) path.setAttribute('d', d);
      if (anim) anim.setAttribute('path', d);
    });

    var rightCards = stage.querySelectorAll('.psp-core-col.right .psp-core-card');
    rightCards.forEach(function (card, i) {
      var r = card.getBoundingClientRect();
      var x = (r.left - stageRect.left) * scaleX;
      var y = (r.top + r.height / 2 - stageRect.top) * scaleY;
      var d = 'M760,280 C 900,280 900,' + y + ' ' + x + ',' + y;
      var path = document.getElementById('psp-core-path-right-' + i);
      var anim = document.getElementById('psp-core-anim-right-' + i);
      if (path) path.setAttribute('d', d);
      if (anim) anim.setAttribute('path', d);
    });
  }

  updateLines();
  setTimeout(updateLines, 300);
  window.addEventListener('resize', function () {
    clearTimeout(window.__pspCoreResizeT);
    window.__pspCoreResizeT = setTimeout(updateLines, 150);
  });
});
